// @core/api/endpoints/user/list_users.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUsersResponse,
} from '../../../types/user';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/user';

/**
 * List users with filters
 * Returns a paginated list of users within the platform, with optional filtering capabilities. Requires platform membership and is typically used by administrators for user management.
 */
export async function ListUsers(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUsersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.get<ListUsersResponse>(requestPath, { ...requestOptions, params });
}
